<!-- Azzurro Table Component (Desktop) -->
<azzurro-table
  *ngIf="paginationConfig"
  id="upgrade-sessions-table"
  [data$]="data$"
  [columns]="columns"
  [pagination]="true"
  [filterEnabled]="true"
  [showColumnToggleButton]="false"
  [uiFramework]="'material'"
  [mode]="'client'"
  [paginationConfig]="paginationConfig"
  [rowClickable]="onSessionSelected.bind(this)"
  [labels]="{
    search: 'Filter sessions',
    noData: labels.noDataMessage || 'No upgrade sessions found',
    noResults: labels.noDataMessage || 'No upgrade sessions found'
  }"
  [noResultTemplate]="noResultTemplate">
</azzurro-table>

<!-- Azzurro Table Component (Mobile) -->
<azzurro-table
  *ngIf="paginationConfig"
  id="upgrade-sessions-list"
  [data$]="data$"
  [columns]="columns"
  [pagination]="true"
  [filterEnabled]="true"
  [showColumnToggleButton]="false"
  [uiFramework]="'ionic'"
  [mode]="'client'"
  [paginationConfig]="paginationConfig"
  [rowClickable]="onSessionSelected.bind(this)"
  [labels]="{
    search: 'Filter sessions',
    noData: labels.noDataMessage || 'No upgrade sessions found',
    noResults: labels.noDataMessage || 'No upgrade sessions found'
  }"
  [noResultTemplate]="noResultTemplate">
</azzurro-table>

<!-- No Result Template -->
<ng-template #noResultTemplate>
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-32 tw-text-gray-500">
    <mat-icon class="tw-text-4xl tw-mb-2">search_off</mat-icon>
    <span>{{ labels.noDataMessage || 'No upgrade sessions found' }}</span>
  </div>
</ng-template>